import { Alert, Button, Paper } from "@mui/material";

export default function ErrorFallback(props: {
  error?: any;
  resetErrorBoundary?: any;
}) {
  return (
    <div
      className="horizontalCenter"
      style={{ width: "100%", height: "100vh" }}
    >
      <Paper
        elevation={4}
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "30px",
        }}
      >
        <p>Something went wrong:</p>
        <Alert severity="error">{props.error.message}</Alert>
        <Button variant="contained" onClick={props.resetErrorBoundary}>
          Try again
        </Button>
      </Paper>
    </div>
  );
}
